"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recaptchaReady = void 0;
const ReadyPromise_1 = require("./util/ReadyPromise");
exports.recaptchaReady = new ReadyPromise_1.RecaptchaReadyPromise();
